
import Vue from 'vue'

// v-focus
Vue.directive('focus', {
    inserted: function(el) {
        el.focus()
    }
})
